import axios from 'axios'
import { AbstractService } from "./abstract.service";
import { AuthService } from "@/services/auth.service";
import $store from "@/state/store"

export class EmployeeService extends AbstractService {
  static get entity() {
    return "n360/mcmnt/api";
  }

  static get URL_GATEWAY() {
    return process.env.VUE_APP_GATEWAY_API_URL;
  }

  // danh sách nhân viên
  static async getListEmployee(params) {
    try {
      const response = await axios.post(
        `${this.URL_GATEWAY}/${this.entity}/alias-user/list`,
        params,
        {
          headers: {
            Authorization: `Bearer ${AuthService.getBearer()}`,
            "np-merchant-id": params.merchantId,
            "np-app-id": process.env.VUE_APP_ID,
            "np-location-id": $store.state.auth.currentLocation
          }
      })
      return response.data
    } catch (error) {
      console.log(error);
    }
  }

  // danh sách full nhân viên theo location
  static async listEmployeeLocation(params) {
    try {
      const response = await axios.post(
        `${this.URL_GATEWAY}/${this.entity}/alias-user/get-by-filter`,
        params,
        {
          headers: {
            Authorization: `Bearer ${AuthService.getBearer()}`,
            "np-merchant-id": params.merchantId,
            "np-app-id": process.env.VUE_APP_ID,
            "np-location-id": $store.state.auth.currentLocation
          }
      })
      return response.data
    } catch (error) {
      console.log(error);
    }
  }

  // chi tiết nhân viên
  static async getDetailEmployee(params) {
    try {
      const response = await this.callApi().post(
        `${this.entity}/alias-user/detail`,
        params
      )
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }

  // cập nhật thông tin nhân viên
  static async updateDetailEmployee(params) {
    try {
      const response = await axios.post(
        `${this.URL_GATEWAY}/${this.entity}/alias-user/update`,
        params,
        {
          headers: {
            Authorization: `Bearer ${AuthService.getBearer()}`,
            "np-merchant-id": params.merchantId,
            "np-app-id": process.env.VUE_APP_ID,
            "np-location-id": $store.state.auth.currentLocation
          }
      })
      return response.data
    } catch (error) {
      console.log(error);
    }
  }

  static async updateDetailEmployeeV2(params) {
    try {
      const response = await axios.patch(
        `${this.URL_GATEWAY}/${this.entity}/alias-users/${params.coAliasUserId}`,
        params.param,
        {
          headers: {
            Authorization: `Bearer ${AuthService.getBearer()}`,
            "np-merchant-id": params.merchantId,
            "np-app-id": process.env.VUE_APP_ID,
            "np-location-id": $store.state.auth.currentLocation
          }
        }
      )
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }

  static async updateEmployeeRoles(param) {
    try {
      
      const response = await axios.post(
        `${this.URL_GATEWAY}/${this.entity}/alias-users/${param.id}/roles`,
        param.roles,
        {
          headers: {
            Authorization: `Bearer ${AuthService.getBearer()}`
          }
        }
      )
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }
  // update quyền nhân viên
  static async updateRoleEmployee(params) {
    try {
      const response = await axios.post(
        `${this.URL_GATEWAY}/${this.entity}/alias-user/update-role`,
        params,
        {
          headers: {
            Authorization: `Bearer ${AuthService.getBearer()}`,
            "np-merchant-id": params.merchantId,
            "np-app-id": process.env.VUE_APP_ID,
            "np-location-id": $store.state.auth.currentLocation
          }
      })
      return response.data
    } catch (error) {
      console.log(error);
    }
  }

  // tạo mới nhân viên
  static async createEmployee(params) {
    try {
      const response = await axios.post(
        `${this.URL_GATEWAY}/${this.entity}/alias-user/create`,
        params,
        {
          headers: {
            Authorization: `Bearer ${AuthService.getBearer()}`,
            "np-app-id": process.env.VUE_APP_ID,
            "np-location-id": $store.state.auth.currentLocation
          }
      })
      return response.data
    } catch (error) {
      console.log(error);
    }
  }

  // đổi mật khẩu acc nhân viên
  static async changePass(params) {
    try {
      const response = await this.callApi().post(
        `${this.entity}/alias-user/reset-password`,
        params
      )
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }

  static async changePassEmployeev2(params) {
    try {
      const response = await this.callApi().post(
        `${this.entity}/alias-users/reset-pwd`,
        params
      )
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }

  // xoá nhân viên
  static async deleteEmployee(params) {
    try {
      const response = await this.callApi().post(
        `${this.entity}/alias-user/delete`,
        params
      )
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }

  // chuyển tài khoản sang ngưng hoạt động
  static async closeAcount(params) {
    try {
      const response = await this.callApi().post(
        `${this.entity}/alias-user/deactivate`,
        params
      )
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }

  // Chuyển tài khoản sang Hoạt động
  static async openAcount(params) {
    try {
      const response = await this.callApi().post(
        `${this.entity}/alias-user/active`,
        params
      )
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }

  static async getEmployeeSOReport(param) {
    try {
      const response = await this.callApi().post(
        `/nsh/odm/api/order/so/employee-report`,
        param
      )
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }
}
